// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"01d460c4","399":"6fc3c972","437":"14b90450","453":"a8aa95b4","467":"0ae017a7","603":"f7b95305","754":"39a3d056","866":"92c7d8fa","871":"13042814","975":"efbbb800"}[chunkId] + ".chunk.js";
};